import React from 'react'


export const RecommenedCourse = ({ data }) => {
    const roles = JSON.parse(sessionStorage.getItem("#roles") || "{}");
    const textColor = roles === "student" ? "text-blueColor" : roles === "teacher" ? "text-primary" : "text-green-500"
    return (
        <div className='flex flex-col gap-4'>
            <div className='flex justify-between items-center'>
                <h2 className='md:text-[16px] text-[#00000] font-ManropeSemibold leading-[20px] '>Recommend Courses</h2>
            </div>
            {
                data.map((course, id) => (
                    <div className='flex gap-2 items-center py-2 pr-6 bg-white'>
                        <img src={course.img} alt="event-image" className='w-[48px] h-[62px] rounded-[4px]' />
                        <div className='flex gap-2 flex-col'>
                            <h2 className='text-[12px] leading-[18px] font-ManropeSemibold'>{course.name}</h2>
                            <p className={`${textColor}`}>{course.category}</p>
                        </div>
                    </div>
                ))
            }
        </div>
    )
}
